import {useEffect} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import { useIsLoginState } from '../components/IsLoginContext';

// 역할 기반 접근 제어 훅
const useRoleBasedAccess = (allowedRoles) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { isLogin, user, isInitialized } = useIsLoginState();

    useEffect(() => {
        // 초기화가 완료된 후에만 권한 체크
        if (!isInitialized) {
            console.log('초기화 대기 중...');
            return;
        }

        // localStorage에서도 체크 (fallback)
        const localRole = localStorage.getItem('role');
        const localToken = localStorage.getItem('access_token');

        // 로그인되지 않은 경우
        if (!isLogin && !localToken) {
            console.log('로그인되지 않음 - 토큰 없음');
            alert('로그인이 필요합니다.');
            navigate('/');
            return;
        }

        // 사용자 정보가 없지만 localStorage에 정보가 있는 경우 (타이밍 이슈)
        if (!user?.role && localRole) {
            console.log('컨텍스트 상태 동기화 대기 중... localStorage role:', localRole);
            // 짧은 지연 후 다시 체크 (컨텍스트 업데이트 대기)
            setTimeout(() => {
                if (!user?.role) {
                    console.log('컨텍스트 동기화 실패, localStorage role 사용:', localRole);
                    if (!allowedRoles.includes(localRole)) {
                        alert('접속 권한이 없습니다.');
                        navigate('/');
                    }
                }
            }, 100);
            return;
        }

        const userRole = user?.role || localRole;
        console.log('Current role:', userRole, 'Allowed roles:', allowedRoles);

        if (!userRole) {
            console.log('역할 정보 없음');
            alert('로그인이 필요합니다.');
            navigate('/');
            return;
        }

        // 허용된 역할이 아닐 경우 메인 페이지로 리다이렉트
        if (!allowedRoles.includes(userRole)) {
            console.log('접근 권한 없음:', userRole, 'not in', allowedRoles);
            alert('접속 권한이 없습니다.');
            navigate('/');
        }
    }, [allowedRoles, navigate, location, isLogin, user, isInitialized]);
};

export default useRoleBasedAccess;